import classnames from 'classnames';
import { map } from 'lodash-es';
import React from 'react';
export function Alert({ messages, type, }) {
    if (!messages.length) {
        return null;
    }
    return (React.createElement("div", { className: classnames('alert', `alert--${type}`) }, map(messages, (message, index) => (React.createElement("div", { key: index }, message)))));
}
